import {AfterViewInit, ApplicationRef, Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ShortProject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import {
  PricingFilter,
  ProjectCalcService
} from 'projects/app-misc/src/app/modules/project-calc/data/project-calc.service';
import {ProjectPricing, ProjectPricingCounters} from '../data/project-pricing';
import {Subject, Subscription, timer} from 'rxjs';
import {LocalStorage} from 'ngx-webstorage';
import {MatDialog} from '@angular/material/dialog';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {
  ProjectWindowComponent
} from '../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {ConfirmationService} from 'primeng/api';
import {WsUpdateResponce} from '../../data/ws-update-responce';
import {debounceTime, filter} from 'rxjs/operators';
import {WsService} from '../../data/ws.service';
import {ProposalPdfDialogComponent} from '../proposal-pdf-dialog/proposal-pdf-dialog.component';
import {ProjectService} from "../../project-misc/data/project/project.service";
import {RouterService} from "../../../../../../core/src/lib/misc/router/router.service";
import {PricingMiscItem} from "../data/misc-item/pricing-misc-item";

@Component({
  selector: 'app-projects-calc-view',
  templateUrl: './projects-calc-view.component.html',
  styleUrls: ['./projects-calc-view.component.scss'],
  providers: [ConfirmationService]
})
export class ProjectsCalcViewComponent implements OnInit, AfterViewInit, OnDestroy {

  pricings: ProjectPricing[]
  options: ProjectPricing[] = []

  pricingFilter: PricingFilter = {}


  pricingProject: ShortProject;
  pricingProjects: ShortProject[] = [];

  @LocalStorage()
  pricingProjectId: number;

  pricingUsers: ShortObject[] = [];
  allUsers: ShortObject[] = [];

  @LocalStorage()
  pricingUserIds: number[];

  pricingCustomer: ShortObject;
  pricingCustomers: ShortObject[] = []

  @LocalStorage()
  pricingCustomerId: number;

  pricingStatus: ShortObject;
  pricingStatuses: ShortObject[] = [];
  @LocalStorage()
  pricingStatusId: number;

  firstLoading = true;
  pricingLoading = true;

  pricingPerPage = 15;

  chosenPricing: ProjectPricing = null;

  totalRecords: number;
  deletePricingId = -1;

  wsSub: Subscription;
  lastChosenPricingSub: Subscription;
  pricingNameSubj: Subscription;

  copyPricingLoading = false;

  optionNameUpdateSubj = new Subject();

  projects: ShortObject[];
  searchPricings: ProjectPricing[] = [];
  searchLoading = true;
  searchValue: string;

  itemsToDelete: PricingMiscItem[] = []

  constructor(
    private el: ElementRef,
    protected dialog: MatDialog,
    public route: ActivatedRoute,
    public router: Router,
    public routerService: RouterService,
    protected wsService: WsService,
    protected projectCalcService: ProjectCalcService,
    protected projectService: ProjectService,
    protected confirmationService: ConfirmationService,
    protected appRef: ApplicationRef
  ) {
    // get misc items
    this.projectCalcService.getThisMiscItems();
    this.projectCalcService.fillMiscGroups();
  }

  ngOnInit(): void {
    this.firstLoading = true;

    timer(1).subscribe(() => {
      if (this.route.firstChild) {
        this.route.firstChild.paramMap.subscribe((params => {
          // tslint:disable-next-line:radix
          const id = parseInt(params.get('id'))
          if (id >= 0) {
            this.pricingLoading = true;

            this.projectCalcService.getDetailPricing(id).subscribe(pricing => {
              this.chosenPricing = pricing;
              this.pricingLoading = false;

              this.getOptions();
              this.getMiscItems()
            }, () => {
              this.pricingLoading = false;
              this.router.navigate(['/pricing'])
            })
          }

        }))
      }
    })

    this.subToChosenProjectEdit()
    this.subToPricingNameChanges()

    this.wsSocketSub()

    // this.getAllPricings()
  }

  subToPricingNameChanges() {
    this.optionNameUpdateSubj.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.projectCalcService.updatePricing({
        id: this.chosenPricing.id,
        name: this.chosenPricing.name
      }).subscribe(() => {
        this.options.forEach(option => {
          if (option.id === this.chosenPricing.id) {
            option.name = this.chosenPricing.name
          }
        })
      })
    })
  }

  getOptions() {
    if (this.options && this.options.length > 0) {
      if (this.options[0].project.id === this.chosenPricing.project.id) {
        return
      }
    }

    this.projectCalcService.getDetailPricingsForProject(this.chosenPricing.project.id).subscribe(pricings => {
      this.options = pricings
    }, () => {
    })
  }

  getMiscItems() {
    this.deleteMiscItems();

    this.projectCalcService.getMiscItemsForProject(this.chosenPricing.project.id).subscribe(miscItems => {
      miscItems.forEach(miscItem => {
        if (!this.projectCalcService.miscItemsMap.has(miscItem.name)) {
          this.projectCalcService.miscItems.push(miscItem)
          this.projectCalcService.miscItemsMap.set(miscItem.name, miscItem)
          this.projectCalcService.miscItemsArr.push(miscItem.name)

          this.itemsToDelete.push(miscItem)
        }
      })
    }, () => {
    })
  }


  subToChosenProjectEdit() {
    this.lastChosenPricingSub = this.projectCalcService.lastChosenPricingSubj.subscribe(lastChosenPricing => {
      this.chosenPricing = lastChosenPricing
    })
  }

  ngAfterViewInit() {
    timer(1).subscribe(() => {
      this.pricingPerPage = Math.max(this.pricingPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 45));

      this.getPricing();
    })
  }


  //socket for update pricing totals in pricing list
  wsSocketSub() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<ProjectPricingCounters>>('/topic/update/model.pricing.pricing', this)
      .pipe(
        filter(updateInfo => !!this.pricings.find(pricing => pricing.id === updateInfo.entity.id)),
        debounceTime(1000)
      )
      .subscribe(updateInfo => {
        const fPricing = this.pricings.find(pricing => pricing.id === updateInfo.entity.id)
        fPricing.cabinetryTotal = updateInfo.entity.cabinetryTotal
        fPricing.subtotal = updateInfo.entity.subtotal
        fPricing.subtotalDelivery = updateInfo.entity.subtotalDelivery
        fPricing.subtotalInstall = updateInfo.entity.subtotalInstall
        fPricing.grandTotal = updateInfo.entity.grandTotal
      })
  }

  getPricing() {
    this.projectCalcService.getPricingFilters().subscribe(filters => {
      this.processFilterProjects(filters.projects)
      this.processFilterUsers(filters.users)
      this.processFilterCustomers(filters.customers)
      this.processFilterStatuses(filters.statuses)


      this.getPricingLazy(0, this.pricingPerPage);
      this.firstLoading = false;
    })
  }


  processFilterProjects(projects: ShortProject[]) {
    this.pricingProjects = projects;

    if (this.pricingProjectId > 0) {
      const fProj = this.pricingProjects.find(proj => proj.id === this.pricingProjectId)

      if (fProj) {
        this.pricingProject = fProj;
        this.pricingFilter.project = [this.pricingProjectId];
      }
    }
  }

  processFilterUsers(users: ShortProject[]) {
    this.allUsers = users;

    if (this.pricingUserIds?.length > 0) {
      const fUsers = this.allUsers.filter(user => this.pricingUserIds?.includes(user.id))

      if (fUsers) {
        this.pricingUsers = fUsers;
        this.pricingFilter.users = fUsers.map(user => user.id);
      }
    }
  }

  processFilterCustomers(customers: ShortObject[]) {
    this.pricingCustomers = customers;

    if (this.pricingCustomerId > 0) {
      const fCustomer = this.pricingCustomers.find(proj => proj.id === this.pricingCustomerId)

      if (fCustomer) {
        this.pricingCustomer = fCustomer;
        this.pricingFilter.customer = [this.pricingCustomerId];
      }
    }
  }

  processFilterStatuses(statuses: ShortObject[]) {
    this.pricingStatuses = statuses;

    if (this.pricingStatusId > 0) {
      const fStatus = this.pricingStatuses.find(proj => proj.id === this.pricingStatusId)

      if (fStatus) {
        this.pricingStatus = fStatus;
        this.pricingFilter.statuses = [this.pricingStatusId];
      }
    }
  }

  getPricingLazy(page: number, rows: number) {
    this.pricingLoading = true;

    this.pricingFilter.start = page
    this.pricingFilter.limit = rows;

    this.projectCalcService.getFilteredPricing(this.pricingFilter).subscribe(pricing => {
      this.pricings = pricing.content
      this.totalRecords = pricing.totalElements;
      this.pricingLoading = false;
    })
  }

  userChange() {
    this.pricingUserIds = this.pricingUsers.map(user => user.id);

    if (this.pricingUserIds.length) {
      this.pricingFilter.users = this.pricingUserIds
    } else {
      this.pricingFilter.users = null;
    }

    this.updateFilter()
  }

  customerChange(event) {
    if (event.value as ShortObject) {
      this.pricingCustomer = event.value;
      this.pricingCustomerId = this.pricingCustomer.id;

      if (this.pricingCustomer) {
        this.pricingFilter.customer = [this.pricingCustomer.id]
      }
    } else {
      this.pricingFilter.customer = undefined;
      this.pricingCustomerId = -1;
    }

    this.updateFilter()
  }

  statusChange(event) {
    if (event.value as ShortObject) {
      this.pricingStatus = event.value;
      this.pricingStatusId = this.pricingStatus.id;

      if (this.pricingStatus) {
        this.pricingFilter.statuses = [this.pricingStatus.id]
      }
    } else {
      this.pricingFilter.statuses = undefined;
      this.pricingStatusId = -1;
    }

    this.updateFilter()
  }

  updateFilter() {
    this.getPricingLazy(0, this.pricingPerPage);
  }

  switchOption(pricing: ProjectPricing) {
    if (this.chosenPricing.id === pricing.id) return;

    this.projectCalcService.deleteContextMenus()

    this.goBack()

    this.appRef.tick()
    this.openPricing(pricing)
  }

  makeActive(option: ProjectPricing, e?) {
    if (e) {
      e.originalEvent.stopPropagation()
    }

    this.options.forEach(opt => {
      opt.active = false;
    })

    option.active = true;

    this.projectCalcService.makeActivePricing(option.id).subscribe(emit => {

    })
  }

  openPricing(projPricing: ProjectPricing) {
    this.chosenPricing = projPricing;

    this.getOptions()
    this.getMiscItems()

    this.router.navigate(['/pricing/' + projPricing.id])
  }

  goBack() {
    this.chosenPricing = null
    this.router.navigate(['/pricing'])
  }

  getProposal() {
    this.dialog.open(ProposalPdfDialogComponent, {
      data: {
        dialogHeader: `Proposal`,
        link: `/pricing/${this.chosenPricing.id}/pdf`,
        showSendButton: true,
        pricing: this.chosenPricing
      },
      panelClass: 'pdf-preview-dialog'
    });

  }

  openProjectWindow(projectId: number) {
    this.dialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: projectId,
      },
      panelClass: 'project-window-dialog'
    });
  }

  copyThisPricing(projectId: number) {
    this.copyPricingLoading = true;
    this.projectCalcService.copyActivePricing(projectId).subscribe(newCopy => {
      this.copyPricingLoading = false;
      this.options.push(newCopy)
    }, () => {
      this.copyPricingLoading = false;
    })
  }

  deletePricing(event, pricing: ProjectPricing, index: number) {
    event.stopPropagation()

    this.confirmationService.confirm({
      header: `Delete pricing?`,
      message: `Delete pricing for ${pricing.project.name}?`,
      accept: () => {
        this.deletePricingId = pricing.id
        this.projectCalcService.deletePricing(pricing.id).subscribe(() => {
          this.pricings.splice(index, 1);
          this.deletePricingId = -1
        }, () => {
          this.deletePricingId = -1
        })
      },
      reject: () => {

      }
    });
  }

  filterProjects(event) {
    const query = event.query;

    this.projectService
      .searchProjects(query)
      .subscribe(projs => {
        this.projects = projs
      })
  }

  // TODO
  getAllPricings() {
    this.projectCalcService.getFilteredPricing({
      start: 0,
      limit: 200
    }).subscribe(pricings => {
      this.searchLoading = false;
      this.searchPricings = pricings.content
      console.log(this.searchPricings)
    })
  }


  openProjectPricing(project: ShortObject) {
    this.searchValue = '';

    this.projectService.getShortPricingByProjectId(project.id).subscribe(pricingId => {
      this.openPricing({
        id: pricingId,
        project: {
          id: project.id
        }
      })
    })
  }

  optionNameUpdate() {
    this.optionNameUpdateSubj.next()
  }

  deleteOption(event, option: ProjectPricing, index: number) {
    event.stopPropagation();

    this.confirmationService.confirm({
      header: `Delete ${option.name}?`,
      message: `Delete this option for ${option.project.name}?`,
      accept: () => {
        this.projectCalcService.deletePricing(option.id).subscribe(() => {
          this.options.splice(index, 1);
          if (this.chosenPricing.id === option.id) {
            this.chosenPricing = this.options[0]

            this.makeActive(this.chosenPricing)
          }
        }, () => {

        })
      },
      reject: () => {

      }
    });
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }

    if (this.optionNameUpdateSubj) {
      this.optionNameUpdateSubj.unsubscribe()
      this.optionNameUpdateSubj = null
    }

    if (this.lastChosenPricingSub) {
      this.lastChosenPricingSub.unsubscribe()
      this.lastChosenPricingSub = null;
    }

    if (this.pricingNameSubj) {
      this.pricingNameSubj.unsubscribe()
      this.pricingNameSubj = null;
    }
  }

  deleteMiscItems() {
    if (this.itemsToDelete.length > 0) {
      this.itemsToDelete.forEach(itemTodelete => {
        const idToDelete = this.projectCalcService.miscItems.findIndex(miscItem => miscItem.id === itemTodelete.id)
        if (idToDelete >= 0) {
          this.projectCalcService.miscItems.splice(idToDelete, 1)
        }

        this.projectCalcService.miscItemsMap.delete(itemTodelete.name)

        const idToDelete2 = this.projectCalcService.miscItemsArr.findIndex(miscItem => miscItem === itemTodelete.name)
        if (idToDelete2 >= 0) {
          this.projectCalcService.miscItemsArr.splice(idToDelete2, 1)
        }
      })
    }

    this.itemsToDelete = []
  }
}
